import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";

type Rule = {
  pattern: string;
  title: (m: RegExpMatchArray | null, p: Record<string, string>) => string;
};

export function useTitle(rules: Rule[], fallback = "App") {
  const loc = useLocation();

  useEffect(() => {
    // simple param extractor
    const params: Record<string, string> = {};
    for (const r of rules) {
      const m = matchPath({ path: r.pattern, end: true }, loc.pathname);
      if (m) {
        Object.assign(params, m.params as Record<string, string>);
        document.title = r.title(null, params);
        return;
      }
    }
    document.title = fallback;
  }, [loc.pathname, rules, fallback]);
}
